jQuery(function () {
  initSlickCarousel();
  initStickyScrollBlock();
  //   	initAccordion();
});

// slick init
function initSlickCarousel() {
  jQuery(".guide-grid-slider").slick({
    slidesToScroll: 1,
    slidesToShow: 5,
    rows: 0,
    prevArrow: '<button class="slick-prev"></button>',
    nextArrow: '<button class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });
}

// initialize fixed blocks on scroll
function initStickyScrollBlock() {
  jQuery("#header").stickyScrollBlock({
    setBoxHeight: false,
    activeClass: "fixed-position",
    positionType: "fixed",
  });
}

// accordion menu init
function initAccordion() {
  jQuery(".sidebar-block__list").slideAccordion({
    opener: ">a",
    slider: "ul",
    animSpeed: 300,
  });
}

/*
 * jQuery Accordion plugin new
 */
(function (root, factory) {
  "use strict";
  if (typeof define === "function" && define.amd) {
    define(["jquery"], factory);
  } else if (typeof exports === "object") {
    module.exports = factory(require("jquery"));
  } else {
    root.SlideAccordion = factory(jQuery);
  }
})(this, function ($) {
  "use strict";
  var accHiddenClass = "js-acc-hidden";

  function SlideAccordion(options) {
    this.options = $.extend(
      true,
      {
        allowClickWhenExpanded: false,
        activeClass: "active",
        opener: ".opener",
        slider: ".slide",
        animSpeed: 300,
        collapsible: true,
        event: "click",
        scrollToActiveItem: {
          enable: false,
          breakpoint: 767, // max-width
          animSpeed: 600,
          extraOffset: null,
        },
      },
      options
    );
    this.init();
  }

  SlideAccordion.prototype = {
    init: function () {
      if (this.options.holder) {
        this.findElements();
        this.setStateOnInit();
        this.attachEvents();
        this.makeCallback("onInit");
      }
    },

    findElements: function () {
      this.$holder = $(this.options.holder).data("SlideAccordion", this);
      this.$items = this.$holder.find(":has(" + this.options.slider + ")");
    },

    setStateOnInit: function () {
      var self = this;

      this.$items.each(function () {
        if (!$(this).hasClass(self.options.activeClass)) {
          $(this).find(self.options.slider).addClass(accHiddenClass);
        }
      });
    },

    attachEvents: function () {
      var self = this;

      this.accordionToggle = function (e) {
        var $item = jQuery(this).closest(self.$items);
        var $actiItem = self.getActiveItem($item);

        if (
          !self.options.allowClickWhenExpanded ||
          !$item.hasClass(self.options.activeClass)
        ) {
          e.preventDefault();
          self.toggle($item, $actiItem);
        }
      };

      this.$items.on(
        this.options.event,
        this.options.opener,
        this.accordionToggle
      );
    },

    toggle: function ($item, $prevItem) {
      if (!$item.hasClass(this.options.activeClass)) {
        this.show($item);
      } else if (this.options.collapsible) {
        this.hide($item);
      }

      if (!$item.is($prevItem) && $prevItem.length) {
        this.hide($prevItem);
      }

      this.makeCallback("beforeToggle");
    },

    show: function ($item) {
      var $slider = $item.find(this.options.slider);

      $item.addClass(this.options.activeClass);
      $slider
        .stop()
        .hide()
        .removeClass(accHiddenClass)
        .slideDown({
          duration: this.options.animSpeed,
          complete: function () {
            $slider.removeAttr("style");
            if (
              this.options.scrollToActiveItem.enable &&
              window.innerWidth <= this.options.scrollToActiveItem.breakpoint
            ) {
              this.goToItem($item);
            }
            this.makeCallback("onShow", $item);
          }.bind(this),
        });

      this.makeCallback("beforeShow", $item);
    },

    hide: function ($item) {
      var $slider = $item.find(this.options.slider);

      $item.removeClass(this.options.activeClass);
      $slider
        .stop()
        .show()
        .slideUp({
          duration: this.options.animSpeed,
          complete: function () {
            $slider.addClass(accHiddenClass);
            $slider.removeAttr("style");
            this.makeCallback("onHide", $item);
          }.bind(this),
        });

      this.makeCallback("beforeHide", $item);
    },

    goToItem: function ($item) {
      var itemOffset = $item.offset().top;

      if (itemOffset < $(window).scrollTop()) {
        // handle extra offset
        if (typeof this.options.scrollToActiveItem.extraOffset === "number") {
          itemOffset -= this.options.scrollToActiveItem.extraOffset;
        } else if (
          typeof this.options.scrollToActiveItem.extraOffset === "function"
        ) {
          itemOffset -= this.options.scrollToActiveItem.extraOffset();
        }

        $("body, html").animate(
          {
            scrollTop: itemOffset,
          },
          this.options.scrollToActiveItem.animSpeed
        );
      }
    },

    getActiveItem: function ($item) {
      return $item.siblings().filter("." + this.options.activeClass);
    },

    makeCallback: function (name) {
      if (typeof this.options[name] === "function") {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },

    destroy: function () {
      this.$holder.removeData("SlideAccordion");
      this.$items.off(
        this.options.event,
        this.options.opener,
        this.accordionToggle
      );
      this.$items.removeClass(this.options.activeClass).each(
        function (i, item) {
          $(item)
            .find(this.options.slider)
            .removeAttr("style")
            .removeClass(accHiddenClass);
        }.bind(this)
      );
      this.makeCallback("onDestroy");
    },
  };

  $.fn.slideAccordion = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];

    return this.each(function () {
      var $holder = jQuery(this);
      var instance = $holder.data("SlideAccordion");

      if (typeof opt === "object" || typeof opt === "undefined") {
        new SlideAccordion(
          $.extend(
            true,
            {
              holder: this,
            },
            opt
          )
        );
      } else if (typeof method === "string" && instance) {
        if (typeof instance[method] === "function") {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };

  (function () {
    var tabStyleSheet = $('<style type="text/css">')[0];
    var tabStyleRule = "." + accHiddenClass;
    tabStyleRule +=
      "{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important; width: 100% !important;}";
    if (tabStyleSheet.styleSheet) {
      tabStyleSheet.styleSheet.cssText = tabStyleRule;
    } else {
      tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
    }
    $("head").append(tabStyleSheet);
  })();

  return SlideAccordion;
});

/*
 * jQuery sticky box plugin
 */
(function ($, $win) {
  "use strict";

  function StickyScrollBlock($stickyBox, options) {
    this.options = options;
    this.$stickyBox = $stickyBox;
    this.init();
  }

  var StickyScrollBlockPrototype = {
    init: function () {
      this.findElements();
      this.attachEvents();
      this.makeCallback("onInit");
    },

    findElements: function () {
      // find parent container in which will be box move
      this.$container = this.$stickyBox.closest(this.options.container);
      // define box wrap flag
      this.isWrap =
        this.options.positionType === "fixed" && this.options.setBoxHeight;
      // define box move flag
      this.moveInContainer = !!this.$container.length;
      // wrapping box to set place in content
      if (this.isWrap) {
        this.$stickyBoxWrap = this.$stickyBox
          .wrap('<div class="' + this.getWrapClass() + '"/>')
          .parent();
      }
      //define block to add active class
      this.parentForActive = this.getParentForActive();
      this.isInit = true;
    },

    attachEvents: function () {
      var self = this;

      // bind events
      this.onResize = function () {
        if (!self.isInit) return;
        self.resetState();
        self.recalculateOffsets();
        self.checkStickyPermission();
        self.scrollHandler();
      };

      this.onScroll = function () {
        self.scrollHandler();
      };

      // initial handler call
      this.onResize();

      // handle events
      $win
        .on("load resize orientationchange", this.onResize)
        .on("scroll", this.onScroll);
    },

    defineExtraTop: function () {
      // define box's extra top dimension
      var extraTop;

      if (typeof this.options.extraTop === "number") {
        extraTop = this.options.extraTop;
      } else if (typeof this.options.extraTop === "function") {
        extraTop = this.options.extraTop();
      }

      this.extraTop =
        this.options.positionType === "absolute"
          ? extraTop
          : Math.min(this.winParams.height - this.data.boxFullHeight, extraTop);
    },

    checkStickyPermission: function () {
      // check the permission to set sticky
      this.isStickyEnabled = this.moveInContainer
        ? this.data.containerOffsetTop + this.data.containerHeight >
          this.data.boxFullHeight +
            this.data.boxOffsetTop +
            this.options.extraBottom
        : true;
    },

    getParentForActive: function () {
      if (this.isWrap) {
        return this.$stickyBoxWrap;
      }

      if (this.$container.length) {
        return this.$container;
      }

      return this.$stickyBox;
    },

    getWrapClass: function () {
      // get set of container classes
      try {
        return this.$stickyBox
          .attr("class")
          .split(" ")
          .map(function (name) {
            return "sticky-wrap-" + name;
          })
          .join(" ");
      } catch (err) {
        return "sticky-wrap";
      }
    },

    resetState: function () {
      // reset dimensions and state
      this.stickyFlag = false;
      this.$stickyBox
        .css({
          "-webkit-transition": "",
          "-webkit-transform": "",
          transition: "",
          transform: "",
          position: "",
          width: "",
          left: "",
          top: "",
        })
        .removeClass(this.options.activeClass);

      if (this.isWrap) {
        this.$stickyBoxWrap
          .removeClass(this.options.activeClass)
          .removeAttr("style");
      }

      if (this.moveInContainer) {
        this.$container.removeClass(this.options.activeClass);
      }
    },

    recalculateOffsets: function () {
      // define box and container dimensions
      this.winParams = this.getWindowParams();

      this.data = $.extend(this.getBoxOffsets(), this.getContainerOffsets());

      this.defineExtraTop();
    },

    getBoxOffsets: function () {
      function offetTop(obj) {
        obj.top = 0;
        return obj;
      }
      var boxOffset =
        this.$stickyBox.css("position") === "fixed"
          ? offetTop(this.$stickyBox.offset())
          : this.$stickyBox.offset();
      var boxPosition = this.$stickyBox.position();

      return {
        // sticky box offsets
        boxOffsetLeft: boxOffset.left,
        boxOffsetTop: boxOffset.top,
        // sticky box positions
        boxTopPosition: boxPosition.top,
        boxLeftPosition: boxPosition.left,
        // sticky box width/height
        boxFullHeight: this.$stickyBox.outerHeight(true),
        boxHeight: this.$stickyBox.outerHeight(),
        boxWidth: this.$stickyBox.outerWidth(),
      };
    },

    getContainerOffsets: function () {
      var containerOffset = this.moveInContainer
        ? this.$container.offset()
        : null;

      return containerOffset
        ? {
            // container offsets
            containerOffsetLeft: containerOffset.left,
            containerOffsetTop: containerOffset.top,
            // container height
            containerHeight: this.$container.outerHeight(),
          }
        : {};
    },

    getWindowParams: function () {
      return {
        height: window.innerHeight || document.documentElement.clientHeight,
      };
    },

    makeCallback: function (name) {
      if (typeof this.options[name] === "function") {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },

    destroy: function () {
      this.isInit = false;
      // remove event handlers and styles
      $win
        .off("load resize orientationchange", this.onResize)
        .off("scroll", this.onScroll);
      this.resetState();
      this.$stickyBox.removeData("StickyScrollBlock");
      if (this.isWrap) {
        this.$stickyBox.unwrap();
      }
      this.makeCallback("onDestroy");
    },
  };

  var stickyMethods = {
    fixed: {
      scrollHandler: function () {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky =
          this.winScrollTop -
            (this.options.showAfterScrolled ? this.extraTop : 0) -
            (this.options.showAfterScrolled
              ? this.data.boxHeight + this.extraTop
              : 0) >
          this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },

      stickyOn: function () {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            position: this.options.positionType,
          });
          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight,
            });
          }
          this.makeCallback("fixedOn");
        }
        this.setDynamicPosition();
      },

      stickyOff: function () {
        if (this.stickyFlag) {
          this.stickyFlag = false;
          this.resetState();
          this.makeCallback("fixedOff");
        }
      },

      setDynamicPosition: function () {
        this.$stickyBox.css({
          top: this.getTopPosition(),
          left: this.data.boxOffsetLeft - $win.scrollLeft(),
        });
      },

      getTopPosition: function () {
        if (this.moveInContainer) {
          var currScrollTop =
            this.winScrollTop + this.data.boxHeight + this.options.extraBottom;

          return Math.min(
            this.extraTop,
            this.data.containerHeight +
              this.data.containerOffsetTop -
              currScrollTop
          );
        } else {
          return this.extraTop;
        }
      },
    },
    absolute: {
      scrollHandler: function () {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky =
          this.winScrollTop > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },

      stickyOn: function () {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            transition: "transform " + this.options.animSpeed + "s ease",
            "-webkit-transition":
              "transform " + this.options.animSpeed + "s ease",
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight,
            });
          }

          this.makeCallback("fixedOn");
        }

        this.clearTimer();
        this.timer = setTimeout(
          function () {
            this.setDynamicPosition();
          }.bind(this),
          this.options.animDelay * 1000
        );
      },

      stickyOff: function () {
        if (this.stickyFlag) {
          this.clearTimer();
          this.stickyFlag = false;

          this.timer = setTimeout(
            function () {
              this.setDynamicPosition();
              setTimeout(
                function () {
                  this.resetState();
                }.bind(this),
                this.options.animSpeed * 1000
              );
            }.bind(this),
            this.options.animDelay * 1000
          );
          this.makeCallback("fixedOff");
        }
      },

      clearTimer: function () {
        clearTimeout(this.timer);
      },

      setDynamicPosition: function () {
        var topPosition = Math.max(0, this.getTopPosition());

        this.$stickyBox.css({
          transform: "translateY(" + topPosition + "px)",
          "-webkit-transform": "translateY(" + topPosition + "px)",
        });
      },

      getTopPosition: function () {
        var currTopPosition =
          this.winScrollTop - this.data.boxOffsetTop + this.extraTop;

        if (this.moveInContainer) {
          var currScrollTop =
            this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          var diffOffset = Math.abs(
            Math.min(
              0,
              this.data.containerHeight +
                this.data.containerOffsetTop -
                currScrollTop -
                this.extraTop
            )
          );

          return currTopPosition - diffOffset;
        } else {
          return currTopPosition;
        }
      },
    },
  };

  // jQuery plugin interface
  $.fn.stickyScrollBlock = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];

    var options = $.extend(
      {
        container: null,
        positionType: "fixed", // 'fixed' or 'absolute'
        activeClass: "fixed-position",
        setBoxHeight: true,
        showAfterScrolled: false,
        extraTop: 0,
        extraBottom: 0,
        animDelay: 0.1,
        animSpeed: 0.2,
      },
      opt
    );

    return this.each(function () {
      var $stickyBox = jQuery(this);
      var instance = $stickyBox.data("StickyScrollBlock");

      if (typeof opt === "object" || typeof opt === "undefined") {
        StickyScrollBlock.prototype = $.extend(
          stickyMethods[options.positionType],
          StickyScrollBlockPrototype
        );
        $stickyBox.data(
          "StickyScrollBlock",
          new StickyScrollBlock($stickyBox, options)
        );
      } else if (typeof method === "string" && instance) {
        if (typeof instance[method] === "function") {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };

  // module exports
  window.StickyScrollBlock = StickyScrollBlock;
})(jQuery, jQuery(window));

// Email Modal
(function () {
  function isMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      ) {
        check = true;
      }
    })(navigator.userAgent || navigator.vendor || window.opera);
    if ($(window).width() < 750) {
      check = true;
    }
    return check;
  }

  function createCookie(name, value, minutes) {
    var expires;

    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      encodeURIComponent(value) +
      expires +
      "; path=/";
  }

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name, "", -1);
  }

  KlaviyoSubscribe.attachToForms("#email_signup_slideout", {
    hide_form_on_success: true,
    success: function ($form) {
      createCookie("JMKlaviyo", "subscribed");
      $(".klaviyo_field_group.select-date-widget").hide();
    },
  });

  KlaviyoSubscribe.attachToForms("#email_signup_footer", {
    hide_form_on_success: false,
    success: function ($form) {
      $form.find(".klaviyo_field_group").hide();
      $form.find(".success_message").show();
    },
  });

  $(document).on("change", "#footer_date", function (event) {
    const [year, month, date] = event.target.value.split("-");
    const $month = document.querySelector(
      '#email_signup_footer select[name="Birthday_month"]'
    );
    const $day = document.querySelector(
      '#email_signup_footer select[name="Birthday_day"]'
    );
    const $year = document.querySelector(
      '#email_signup_footer input[name="Birthday_year"]'
    );

    event.target.classList.add("active");
    $month.value = month;
    $day.value = date;
    $year.value = year;
  });

  $(document).on("ready", () => {
    console.warn("Cookie", readCookie("JMKlaviyo"));
    if (!readCookie("JMKlaviyo")) {
      $("#shopify-section-email_modal").removeClass("hide");
    }

    $("#shopify-section-email_modal").removeClass("hide");
    if (isMobile()) {
      $(".popup-peak").on("click touch", () => {
        console.log("Show on Mobile");
        $("#shopify-section-email_modal").toggleClass("open");
      });
    }
  });

  $(document).on("click", "#closeModal", function () {
    createCookie("JMKlaviyo", "subscribed");
    $("#shopify-section-email_modal").addClass("hide");
  });
})(jQuery, jQuery(window));
// end of Email Modal
